import {
  sanity_image_default
} from "./chunk-S7ZUUURB.js";
import {
  title_default
} from "./chunk-GI6JXUKL.js";
import {
  link_default
} from "./chunk-6WQWOYMP.js";
import {
  label_default
} from "./chunk-AWEODRKT.js";

// src/cards/product/product.tsx
import { forwardRef } from "react";
import { jsx, jsxs } from "react/jsx-runtime";
var CardProduct = forwardRef(
  ({
    availableToPurchase,
    className = "",
    eyebrow = "Cherry Lane Theatre",
    id,
    image,
    isBackInStock,
    isNew,
    labels = {
      flagBackInStock: "Back In Stock",
      currency: "$",
      eyebrowPrefix: "From",
      learnMore: "Learn More",
      flagNew: "New"
    },
    price,
    targetPage,
    title
  }, ref) => {
    if (!title) return null;
    return /* @__PURE__ */ jsx(
      "article",
      {
        className: `${className} group overflow-hidden relative auto-rows-min theme-light`,
        id,
        ref,
        children: /* @__PURE__ */ jsxs("div", { className: "card-wrapping-link grid grid-cols-1 relative", children: [
          isBackInStock && !isNew && /* @__PURE__ */ jsx("span", { className: "absolute z-10 left-0 order-1 top-[0.5rem]", children: /* @__PURE__ */ jsx(
            label_default,
            {
              text: isBackInStock ? labels.flagBackInStock : "",
              className: "label-notification-default"
            }
          ) }),
          isNew && /* @__PURE__ */ jsx("span", { className: "absolute z-10 left-0 order-1 top-[0.5rem]", children: /* @__PURE__ */ jsx(
            label_default,
            {
              text: isNew ? labels.flagNew : "",
              className: "label-notification-default"
            }
          ) }),
          title && /* @__PURE__ */ jsx(
            title_default,
            {
              className: "heading-sm order-3 pb-2 pl-1",
              level: "h3",
              text: title
            }
          ),
          eyebrow && /* @__PURE__ */ jsx(
            label_default,
            {
              text: `${labels.eyebrowPrefix} ${eyebrow}`,
              className: "body-xs order-2 pb-2 pl-1 uppercase"
            }
          ),
          price && /* @__PURE__ */ jsxs("span", { className: "body-lg order-4 pb-4 pl-1 text-heritage-off-white-40", children: [
            labels.currency,
            price
          ] }),
          image && /* @__PURE__ */ jsx(
            sanity_image_default,
            {
              className: "order-1 mb-3 relative rounded-sm overflow-hidden",
              imageClassName: "object-cover w-full group-hover:scale-[105%] transition-card-image",
              sanityImageSourceData: image,
              height: 280,
              width: 420
            }
          ),
          targetPage && /* @__PURE__ */ jsx("div", { className: "order-5", children: /* @__PURE__ */ jsx(
            link_default,
            {
              className: "link w-fit",
              href: targetPage || "#",
              tracking: {
                component: "Card Product",
                label: title
              },
              children: /* @__PURE__ */ jsx("span", { className: "sr-only", children: labels.learnMore })
            }
          ) })
        ] })
      }
    );
  }
);
var product_default = CardProduct;

export {
  product_default
};
